import { PrivatePageLayout } from "components/common/layouts/Page/private";

export function DashboardPage() {
    return <PrivatePageLayout link={""} activeLink={"Dashboard"} title={"Dashboard"}>
        <></>
    </PrivatePageLayout>
}